<template>
  <div class="input-text-component">
    <div v-if="title" class="common-input-title">{{ title }}</div>
    <div class="common-input-value">
      <div v-if="errorMessage" class="warning-text">{{ errorMessage }}</div>

      <input
        v-if="type === 'text'"
        class="common-input"
        :type="type"
        :name="name"
        :class="`${customClass} ${errorMessage ? 'error' : ''}`"
        :value="text"
        :inputmode="validation && validation.includes('number') ? 'numeric' : 'text'"
        @input="handleInput"
        @change="checkValid"
        @blur="checkValid"
        autocomplete="off"
      />

      <div v-if="type === 'password'" class="input-password">
        <input
          class="common-input"
          :class="`${customClass} ${errorMessage ? 'error' : ''}`"
          :type="showPassword ? 'text' : 'password'"
          :name="name"
          :value="password"
          @keyup="checkValid"
          @change="checkValid"
          @blur="checkValid"
          autocomplete="off"
        />
        <button class="lock-icon" @click="onShowPassword">
          <img
            v-if="showPassword"
            src="/img/common/pass_on.png"
            alt="pass_on"
          />
          <img v-else src="/img/common/pass_off.png" alt="pass_off" />
        </button>
      </div>

      <div v-if="type === 'select'">
        <!-- :class="`${customClass} ${errorMessage ? 'error' : ''}`" -->
        <a-select
          class="common-select"
          v-model="select"
          :value="select"
          @change="checkValid"
          @blur="selectOnBlur"
        >
          <!-- @blur="checkValid" -->
          <a-select-option
            v-for="(item, index) in selectList"
            :key="index"
            :value="item.value"
            >{{ item.text }}</a-select-option
          >
        </a-select>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue";
import { useStore } from "vuex";
import * as vali from "@/utils/validation";

export default {
  name: "InputComponent",
  props: {
    customClass: String, // 추가할 클래스 이름
    type: String, // input 타입
    title: String, // input 제목(라벨)
    name: String, // 저장소에 저장할 이름
    value: String, // 저장소에 저장할 값
    moduleName: String, // 저장소 이름
    validation: Array, // 에러 체크 조건

    selectList: Array, // select 메뉴
  },
  setup(props, { emit }) {
    const store = useStore();

    const state = reactive({
      text: props.value || "",
      password: props.value || "",
      select: props.value || "",
      showPassword: false,
      errorMessage: "",
    });

    const onShowPassword = () => {
      state["showPassword"] = !state["showPassword"];
    };

    // select blur 이벤트 시 입력 값 체크(onChange와 다른 값이 넘어오므로 별도 처리)
    const selectOnBlur = (e) => {
      let errorText = "";
      if (props.validation) {
        props.validation.map((name, index) => {
          const error = vali[name](state["select"]);
          if (error) {
            errorText = error;
          }
        });
      }
      state["errorMessage"] = errorText;
    };

    // 실시간 입력 처리 (숫자만 허용)
    const handleInput = (e) => {
      // 부모 컴포넌트에 input 이벤트 emit (에러 메시지 초기화용)
      emit('input', e);
      // 경곡 팝업 처리후 입력값 체크
      checkValid(e);
      let inputValue = e.target.value;
      
      // validation에 'number'가 포함되어 있으면 숫자만 허용
      if (props.validation && props.validation.includes('number')) {
        inputValue = inputValue.replace(/[^0-9]/g, '');
        e.target.value = inputValue;
      }
      
      state[props.type] = inputValue;
    };

    // 입력 값 체크
    const checkValid = (e) => {
      const inputValue = props.type === "select" ? e : e.target.value;
      state[props.type] = inputValue;
      let errorText = "";
      if (props.validation) {
        props.validation.map((name, index) => {
          const error = vali[name](state[props.type]);
          if (error) {
            errorText = error;
          }
        });
      }
      state["errorMessage"] = errorText;

      // 저장소에 입력 값 저장
      store.dispatch(`${[props.moduleName]}/SET_INPUT_VALUE`, {
        [props.name]: inputValue,
      });
    };

    return {
      ...toRefs(state),
      handleInput,
      checkValid,
      selectOnBlur,
      onShowPassword,
    };
  },
};
</script>

<style lang="scss" scoped>
.input-text-component {
  width: 100%;

  .common-input-title {
    color: #838383;
    font-size: 13px;
    margin-bottom: 5px;
  }

  .common-input-value {
    position: relative;

    .warning-text {
      margin: 0;
      padding: 3px 10px;
      position: absolute;
      top: -35px;
      right: 0;
      background-color: #da4845;
      color: #ffffff;
      font-size: 12px;
      font-weight: 700;
      border: 1px solid #da4845;
      border-radius: 3px;
      z-index: 999;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);

      &::after {
        position: absolute;
        top: 23px;
        right: 10px;
        content: "";
        border-top: 7px solid #da4845;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
      }
    }

    .common-input {
      width: 100%;
      height: 40px;
      text-indent: 10px;
      border: 1px solid #d9d9d9;
      border-radius: 5px;

      &:focus {
        outline: none;
      }

      &.error {
        background-color: #ffffff !important;
        border: 1px solid #da4845 !important;
      }
    }

    .input-password {
      display: flex;
      align-items: center;

      .common-input {
        padding-right: 42px;
      }

      .lock-icon {
        position: absolute;
        right: 10px;
        background: transparent;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }

    .common-select {
      border-radius: 5px;

      &.error {
        background-color: #ffffff !important;
        border: 1px solid #da4845 !important;
      }
    }
  }
}
</style>